import { DaaSNotification } from '../contracts/notifications';
import { APIError } from '../errors/APIError';
import { useAPIMutation, useAPIQuery } from '../useAPIProvider';

export const useNotifications = (mspId?: string, customerId?: string) => {
  return useAPIQuery(['getNotifications', mspId, customerId], async client => {
    if (mspId && customerId) {
      const response = await client.notifications.getNotifications({
        params: { customerId, mspId },
        query: { notificationType: 1 }
      });
      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body.items.map(item => ({ ...item, createdOn: new Date(item.createdOn) })) as DaaSNotification[];
    } else if (mspId) {
      const response = await client.notifications.getMspNotifications({
        params: { mspId },
        query: { notificationType: 1 }
      });
      if (response.status !== 200) throw APIError.fromResponse(response);

      return response.body.items.map(item => ({ ...item, createdOn: new Date(item.createdOn) })) as DaaSNotification[];
    } else {
      return [] as DaaSNotification[];
    }
  });
};

export const useReadNotification = (mspId?: string, customerId?: string) => {
  return useAPIMutation((client, query) => {
    return async (notificationId: string) => {
      if (mspId && customerId) {
        const response = await client.notifications.readNotification({
          params: { customerId, mspId, notificationId },
          body: { processedOn: new Date().toISOString() }
        });

        if (response.status !== 200) throw APIError.fromResponse(response);

        await query.invalidateQueries(['getNotifications']);
        return response.body;
      } else if (mspId) {
        const response = await client.notifications.readNotificationMsp({
          params: { mspId, notificationId },
          body: { processedOn: new Date().toISOString() }
        });

        if (response.status !== 200) throw APIError.fromResponse(response);

        await query.invalidateQueries(['getNotifications']);
        return response.body;
      } else {
        throw Error('Read notification is currently not supported for admins.');
      }
    };
  });
};
